// removed by extract-text-webpack-plugin
module.exports = {"title":"d_-q7BCQ5biHZb3anJV4P"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/UserBoxStats/widget.scss
// module id = 1272
// module chunks = 0